import { createFileRoute } from "@tanstack/react-router";

import { ProfilPage } from "@/features/moi/ProfilPage";

export const Route = createFileRoute("/_connecte/profil")({
  component: ProfilPage,
});
